import { Box, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { MeansOfTransport, Terminal } from 'modules/global/adapters/crpAPI';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { errorMessage } from 'store/actions/messageActions';
import store from 'store/store';
import useStyles from './styles';
import { Autocomplete } from '@mui/material';
import { LABEL } from 'theme/constants';

type Props = {
  terminals: Terminal[] | undefined;
  terminalNxtEntityIdError: string | undefined;
  meansOfTransportError: string | undefined;
  creationDateError: string | undefined;
  isLoadingError: boolean;
  isFetching: boolean;
};

const PickUpSearchStep = ({
  terminals,
  terminalNxtEntityIdError,
  isLoadingError,
  isFetching,
}: Props) => {
  const { t } = useTranslation(['glossary', 'useCase']);
  const { classes } = useStyles();

  const terminalNxtEntityIdHasError = Boolean(terminalNxtEntityIdError);

  React.useEffect(() => {
    isLoadingError && store.dispatch(errorMessage(t('messages.errorGetAssignPickUpFilterData')));
  }, [isLoadingError, t]);

  return (
    <React.Fragment>
      <Box marginTop={2}>
        <Field name="equipmentNumber" id="equipmentNumber">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <TextField {...field} variant="outlined" label={t('equipmentNumber')} fullWidth />
            </React.Fragment>
          )}
        </Field>
      </Box>
      <Box marginTop={2}>
        <Field name="billOfLadingNumber" id="billOfLadingNumber">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <TextField {...field} variant="outlined" label={t('billOfLadingNumber')} fullWidth />
            </React.Fragment>
          )}
        </Field>
      </Box>
      <Box marginTop={2}>
        <Field name="terminalNxtEntityId" id="terminalNxtEntityId">
          {({ field, form }: FieldProps) => (
            <Autocomplete
              id="inpTerminalCode"
              options={terminals || []}
              getOptionLabel={(terminal: Terminal) =>
                `${terminal.name} (${terminal.portLoCode} ${terminal.code})`
              }
              value={terminals?.find((t) => t.nxtEntityId === field.value) || null}
              onChange={(_, value) => {
                form.setFieldValue('terminalNxtEntityId', value ? value.nxtEntityId : '');
              }}
              renderInput={(params) => (
                <TextField {...params} label={LABEL.CHOOSE_TERMINAL} fullWidth variant="outlined" />
              )}
              fullWidth
              getOptionDisabled={() => isFetching}
              disabled={isFetching}
            />
          )}
        </Field>
      </Box>
      <Box marginTop={2}>
        <Field name="meansOfTransport" id="meansOfTransport">
          {({ field, form }: FieldProps) => (
            <React.Fragment>
              <InputLabel id="meansOfTransport">{t('meansOfTransport')}</InputLabel>
              <Select
                name="meansOfTransport"
                value={field.value}
                fullWidth
                variant="outlined"
                onChange={form.handleChange}
              >
                {Object.keys(MeansOfTransport).map((status) => (
                  <MenuItem value={status} key={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </React.Fragment>
          )}
        </Field>
        <FormHelperText className={classes.errorText}>{terminalNxtEntityIdError}</FormHelperText>
      </Box>
      <Box marginTop={2}>
        <Field name="creationDate" id="creationDate">
          {({ field, form }: FieldProps) => (
            <React.Fragment>
              <InputLabel id="creationDate">{t('creationDate')}</InputLabel>
              <TextField
                id="creationDate"
                fullWidth
                type="date"
                value={field.value}
                onChange={form.handleChange}
                variant="outlined"
              />
            </React.Fragment>
          )}
        </Field>
        <FormHelperText className={classes.errorText}>{terminalNxtEntityIdError}</FormHelperText>
      </Box>
    </React.Fragment>
  );
};
export default PickUpSearchStep;
